import React, { Component } from 'react';
import {Pagination} from "react-bootstrap";
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from './components/Table';
import ActionsPopup from "./components/ActionsPopup";
import API from '../../services/API';
import { PAGE_LIMIT } from "../../data/config";

class History extends Component {
    constructor() {
        super();

        this.state = {
            params: [],
            report: [],
            names: [],
            actionsToShow: null,
            pagesTotal: 0,
            activePage: 1,
            isLoading: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePageSelect = this.handlePageSelect.bind(this);
        this.onActionsPopupHide = this.onActionsPopupHide.bind(this);
        this.onActionsShow = this.onActionsShow.bind(this);
    }

    componentDidMount() {
        this.setState({ isLoading: true });

        API.History.getNames()
            .then(({ names }) => this.setState({ names, isLoading: false }));
    }


    handleSubmit(filters) {
        this.setState({ isLoading: true });

        API.History.get(filters).then(({ report, params }) => {
            const pagesTotal = Math.ceil(report.length / PAGE_LIMIT);

            this.setState({ params, report, activePage: 1, pagesTotal, isLoading: false })
        });
    }

    handlePageSelect(activePage) {
        this.setState({ activePage });
    }

    onActionsShow(actions) {
        this.setState({ actionsToShow: actions });
    }

    onActionsPopupHide() {
        this.setState({ actionsToShow: null });
    }

    getActionsPopup() {
        const { actionsToShow } = this.state;

        if(actionsToShow) return <ActionsPopup actions={actionsToShow} onHide={this.onActionsPopupHide}/>;
    }

    getTable() {
        let { params, report, activePage } = this.state;

        if(report.length) {
            const pageStart = ( activePage - 1 ) * PAGE_LIMIT;
            const pageEnd = activePage * PAGE_LIMIT;
            report = report.slice(pageStart, pageEnd);

            return <Table params={params} report={report} onActionsPopup={this.onActionsShow}/>;
        }

        return <p>No Data</p>
    }

    render() {
        const { isLoading, names } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="History"/>
                <Form names={names} onSubmit={this.handleSubmit}/>
                {this.getActionsPopup()}
                {this.getTable()}

                <Pagination
                    items={this.state.pagesTotal}
                    maxButtons={20}
                    onSelect={this.handlePageSelect}
                    activePage={this.state.activePage}
                />
            </Container>
        );
    }
}

export default History;



// WEBPACK FOOTER //
// ./src/scenes/History/index.js